import { Reveal, Overline } from "@/components/site/Reveal";
import { FloatingDecor } from "@/components/site/FloatingDecor";
import { IMAGES } from "@/lib/site";
import { useLang } from "@/context/LanguageContext";

export const President = () => {
  const { t } = useLang();
  const quote = t("president.quote");
  const highlight = t("president.quoteHighlight");
  const [before, after] = quote.split(highlight);

  return (
    <section id="president" data-testid="president-section" className="relative bg-white py-24 md:py-36 overflow-hidden">
      <FloatingDecor />
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          <div className="md:col-span-5">
            <Reveal>
              <div className="relative">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={IMAGES.president}
                    alt="Herbert Joseph, President of Focus Haitian Music"
                    className="w-full h-full object-cover object-[50%_18%]"
                  />
                  <div className="absolute inset-0 ring-1 ring-inset ring-[#D4AF37]/40" />
                </div>
                <div className="absolute -top-5 -left-5 w-24 h-24 border-t border-l border-[#D4AF37]" />
                <div className="absolute -bottom-5 -right-5 w-24 h-24 border-b border-r border-[#D4AF37]" />
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-7">
            <Reveal delay={0.1}>
              <Overline>{t("president.overline")}</Overline>
              <blockquote className="mt-8 font-display text-2xl md:text-3xl lg:text-[2.4rem] leading-[1.35] text-[#0A1128]">
                <span className="text-[#D4AF37]">“</span>
                {before}
                <span className="italic text-[#B8901F]">{highlight}</span>
                {after}
                <span className="text-[#D4AF37]">”</span>
              </blockquote>
              <div className="mt-8 space-y-5 text-base md:text-lg text-[#4B5563] leading-relaxed max-w-2xl">
                <p>{t("president.p1")}</p>
                <p>{t("president.p2")}</p>
              </div>
              <div className="mt-10 flex items-center gap-5">
                <span className="w-14 gold-rule" />
                <div>
                  <p className="font-display text-xl text-[#0A1128]">{t("president.name")}</p>
                  <p className="text-sm text-[#B8901F] uppercase tracking-[0.15em]">{t("president.role")}</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
